.section__step_nav {
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  margin-bottom: 20px;

  // Let clicks on a disabled Next button reach the section wrapper,
  // which highlights the first incomplete dropdown (see handleDisabledNavClick).
  button:disabled {
    pointer-events: none;
  }

  .compare {
    text-decoration: line-through;
    font-weight: 400;
  }

  .price {
    font-weight: 800;
  }

  .back {
    cursor: pointer;
    font-family: var(--font-family, 'sofia-pro, sans-serif');
    font-size: 18px;
    font-weight: 800;
    line-height: 27px;
    text-align: center;
    margin-right: 15px;
    color: #000;
    border: 0;
    background-color: transparent;
  }
}

.section__step_info {
  font-family: var(--font-family, 'sofia-pro, sans-serif');
  font-size: 14px;
  font-weight: 400;
  line-height: 27px;
  text-align: center;
  margin-top: 10px;
  color: #000;
  border: 0;
}

.loader {
  width: 24px;
  height: 24px;
  border: 3px solid #FFF;
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}

.loader_black {
  border-color: #000;
  border-bottom-color: transparent;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.preorder_btn {
    margin-top: 20px;
    background-color: white !important;
    border: 1px solid black !important;
    box-shadow: none !important;
    border-radius: 4px !important;
    font-family: var(--font-family, 'sofia-pro, sans-serif');
    font-size: 18px;
    font-weight: 800;
    line-height: 27px;
    text-align: center;
    border: 0;
    padding: 10px 20px;
    cursor: pointer;
    .btn_inner {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap:0;
    }
}
.preorder_text {
    font-family: var(--font-family, 'sofia-pro, sans-serif');
    font-size: 18px;
    font-weight: 800;
    line-height: 27px;
    text-align: center;
    color: #000;
    display: block;
}
.preorder_info {
    font-family: var(--font-family, 'sofia-pro, sans-serif');
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
    text-align: center;
    color: #666;
    display: block;
}